import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=f01d171c&scoped=true"
var script = {}
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=f01d171c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01d171c",
  null
  
)

export default component.exports